<template>
  <v-dialog v-model="viewDialog" class="the-app-dialogs" persistent max-width="1000px">
    <v-card>
      <v-layout row class="no-select not-printable" style="background-color:#09132f">
        <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
          <v-layout align-center>
            <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
            <span class="px-3">{{ $t(`View Destructed Asset's Information`) }}</span>
          </v-layout>
        </h3>
        <v-spacer />
        <v-card-actions>
          <v-btn fab icon dark @click="$emit('hidemodal')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-layout>

      <v-card-title class="view-dialog-content grey lighten-3" id="printArea">
        <invoice-header class="only-for-print" />

        <v-layout column>
          <table class="section-title-table only-for-print">
            <tr>
              <th class="section-title-content">
                {{ $t('Destructed Asset') }}
              </th>
            </tr>
          </table>

          <v-layout row wrap pa-2 class="invoice-content">
            <table class="info-table" style="width: 100%">
              <tr>
                <td class="td-padding-bottom">
                  <div class="caption no-select">
                    {{ $t('Destructed Number') }}
                  </div>
                  <strong>{{ viewInfo.damagedNumber || '-' }}</strong>
                </td>
                <td class="td-padding-bottom">
                  <div class="caption no-select">{{ $t('Outlet Name') }}</div>
                  <strong>{{ viewInfo.outletName || '-' }}</strong>
                </td>
                <td class="td-padding-bottom">
                  <div class="caption no-select">{{ $t('Date') }}</div>
                  <strong v-if="viewInfo.damagedDate">
                    {{ viewInfo.damagedDate }}
                  </strong>
                  <strong v-else>-</strong>
                </td>
              </tr>
              <tr>
                <td class="td-padding-bottom">
                  <div class="caption no-select">{{ $t('Asset Type') }}</div>
                  <strong>{{ $t(viewInfo.assetType) }}</strong>
                </td>
                <td class="td-padding-bottom">
                  <div class="caption no-select">
                    {{ $t('Destructed Type') }}
                  </div>
                  <strong>{{ $t(viewInfo.damagedType) }}</strong>
                </td>
              </tr>
              <tr>
                <td class="td-padding-bottom">
                  <div class="caption no-select">{{ $t('Note') }}</div>
                  <strong v-html="lnToBr(viewInfo.note) || '-'" />
                </td>
              </tr>
            </table>

            <table class="printed-table" cellspacing="0">
              <thead>
                <tr class="only-for-print">
                  <td>
                    <div class="header-space">&nbsp;</div>
                  </td>
                </tr>
                <tr>
                  <th xs1 class="pa-2 view-table-header">#</th>
                  <th class="view-table-header" xs7 pa-2>
                    {{ $t('Product') }}
                  </th>
                  <th class="view-table-header" xs6 pa-2 v-if="hasCollection">
                    {{ $t('Collections') }}
                  </th>
                  <th class="view-table-header" xs2>
                    {{ $t('Destructed Date') }}
                  </th>
                  <th class="view-table-header" xs2 pa-2>
                    {{ $t('Quantity') }}
                  </th>
                  <th class="view-table-header" xs2 pa-2>{{ $t('Price') }}</th>
                  <th class="view-table-header" xs2 pa-2>{{ $t('Total') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="rowNumbers > 0">
                  <tr v-for="(row, index) in rowNumbers" :key="index">
                    <td class="view-table-row">
                      <p class="view-table-content">{{ index + 1 }}</p>
                    </td>
                    <td class="view-table-row">
                      <p class="view-table-content">
                        {{ viewInfo.productName[index] }}
                      </p>
                    </td>
                    <td class="view-table-row" v-if="hasCollection">
                      <p class="view-table-content">
                        {{ viewInfo.collection_name[index] }}
                      </p>
                    </td>
                    <td class="view-table-row">
                      <p class="view-table-content">
                        {{ viewInfo.damagedDateTime[index] }}
                      </p>
                    </td>
                    <td class="view-table-row">
                      <p class="view-table-content">
                        {{ viewInfo.damagedQuantity[index] | currency }}
                      </p>
                    </td>
                    <td class="view-table-row">
                      <p class="view-table-content">
                        {{ viewInfo.lossPrice[index] | currency }}
                      </p>
                    </td>
                    <td class="view-table-row">
                      <p class="view-table-content">
                        {{ viewInfo.total[index] | currency }}
                      </p>
                    </td>
                  </tr>
                  <tr class="last-table-row-for-currency">
                    <td class="last-table-row" :colspan="hasCollection ? 6 : 5">
                      <p class="view-table-content">
                        {{ `${$t('Total Loss Price')} (${systemCurrency})` }}
                      </p>
                    </td>
                    <td class="last-table-row2">
                      <p class="view-table-content">
                        {{ viewInfo.totalLossPrice | currency }}
                      </p>
                    </td>
                  </tr>
                </template>
              </tbody>
              <tfoot>
                <tr class="only-for-print">
                  <td>
                    <div class="footer-space">&nbsp;</div>
                  </td>
                </tr>
              </tfoot>
            </table>

            <invoice-footer
              :showSignatureSection="false"
              :accountantName="''"
              :payerRecipientName="''"
              :payerOrRecipient="''"
              class="only-for-print"
            />
          </v-layout>
        </v-layout>
      </v-card-title>
      <v-divider light />

      <v-card-actions class="grey lighten-3 not-printable">
        <v-layout justify-end>
          <v-btn outline color="primary" @click="$emit('hidemodal')">
            {{ $t('Close') }}
          </v-btn>
          <v-btn color="primary" @click="printMe()">
            <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">print</v-icon>
            {{ $t('Print') }}
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import ignored from 'print-this'

export default {
  name: 'view-component',

  components: {
    imageViewer: () => import('@/views/_partials/AppImageViewer.vue'),
    invoiceHeader: () => import('@/views/_partials/invoiceHeader.vue'),
    invoiceFooter: () => import('@/views/_partials/invoiceFooter.vue')
  },

  props: {
    viewDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      dialogs: {
        imageViewerDialog: false
      },
      rowNumbers: 0,
      datePicker: false,
      viewInfo: {
        damagedId: 0,
        damagedNumber: 0,
        damagedType: '',
        assetType: '',
        totalLossPrice: 0,
        status: 0,
        note: '',
        damagedDate: '',
        outletName: '',
        productName: [],
        collection_name: [],
        damagedQuantity: [],
        damagedDateTime: [],
        lossPrice: [],
        total: []
      }
    }
  },

  computed: {
    ...mapGetters({
      damagedInfo: 'destructedAssets/getDamagedProductInfo',
      settings: 'configurations/getSystemSettings'
    }),
    hasCollection() {
      return this.settings.production_collections === 'Active'
    }
  },

  watch: {
    viewDialog: {
      immediate: false,
      handler() {
        if (this.viewDialog) {
          this.rowNumbers = this.damagedInfo.data_detail.length
          this.viewInfo.damagedId = this.damagedInfo.data.damaged_id
          this.viewInfo.damagedNumber = this.damagedInfo.data.damaged_auto_number
          this.viewInfo.damagedType = this.damagedInfo.data.damaged_type
          this.viewInfo.assetType = this.damagedInfo.data.asset_type
          this.viewInfo.totalLossPrice = this.damagedInfo.data.total_loss_price
          this.viewInfo.note = this.damagedInfo.data.damaged_note
          this.viewInfo.status = this.damagedInfo.data.damaged_status
          this.viewInfo.damagedDate = this.damagedInfo.data.damaged_date
          this.viewInfo.outletName = this.damagedInfo.data.outlet_name

          this.viewInfo.productName = []
          this.viewInfo.collection_name = []
          this.viewInfo.damagedQuantity = []
          this.viewInfo.damagedDateTime = []
          this.viewInfo.lossPrice = []
          this.viewInfo.total = []

          this.damagedInfo.data_detail.forEach(e => {
            this.viewInfo.productName.push(e.product_name)
            this.viewInfo.collection_name.push(e.collection_name)
            if (this.viewInfo.collection_name) {
              this.viewInfo.damagedQuantity.push(e.damaged_collection_quantity)
            } else {
              this.viewInfo.damagedQuantity.push(e.damaged_quantity)
            }
            this.viewInfo.lossPrice.push(e.loss_price)
            this.viewInfo.total.push(e.loss_price * e.damaged_quantity)
            this.viewInfo.damagedDateTime.push(e.damaged_date_time.substr(0, 10))
          })
        }
      }
    }
  },

  updated() {
    document.addEventListener('keyup', e => {
      // if the "ESC" button was pressed and this dialog is shown, hide it
      if (e.keyCode === 27 && this.viewDialog) {
        this.$emit('hidemodal')
      }
    })
  },

  methods: {
    lnToBr(str) {
      return helpers.newLineToBreakLine(str)
    },

    printMe() {
      let onlyForPrint = document.querySelectorAll('.only-for-print')
      let notPrintable = document.querySelectorAll('.not-printable')
      let invoiceContent = document.querySelector('.invoice-content')
      let theDialogContent = document.querySelector('.view-dialog-content')
      let infoTable = document.querySelector('.info-table')
      theDialogContent.classList.remove('grey')
      infoTable.classList.add('add-padding-for-info-table')
      invoiceContent.style.marginTop = '90px'
      notPrintable.forEach(element => {
        element.style.display = 'none'
      })
      onlyForPrint.forEach(element => {
        element.style.display = 'block'
      })
      document.querySelector('.printed-table').style.marginTop = '-120px'

      this.$htmlToPaper('printArea', () => {
        infoTable.classList.remove('add-padding-for-info-table')
        theDialogContent.classList.add('grey')
        invoiceContent.style.marginTop = '0px'
        onlyForPrint.forEach(element => {
          element.style.display = 'none'
        })
        notPrintable.forEach(element => {
          element.style.display = 'flex'
        })
        document.querySelector('.printed-table').style.marginTop = '0px'
      })
    }
  }
}
</script>

<style scoped>
.only-for-print {
  display: none;
}
</style>
